<template>
  <div class="operation-box">
    <div
      :class="{disStatus:!row.allowRebind}"
      @click="boundSite()"
    >
      绑定站点
    </div>
    <div
      v-auth="[$_buttonPermission.PLATFORM_SITEMANAGEMENT_OPERATION]"
      @click="compile()"
    >
      编辑
    </div>
    <div @click="details()">
      查看详情
    </div>
  </div>
</template>

<script>

export default {
  name: 'Operation',
  props: {
    row: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    boundSite() {
      if (!this.row.allowRebind) return;
      this.$emit('bound', this.row);
    },
    compile() {
      this.$emit('add', this.row);
    },
    details() {
      this.$emit('detail', this.row);
    },
  },
};
</script>

<style lang="scss" scoped>
.operation-box{
  display: flex;
  justify-content: space-around;
  div{
    cursor: pointer;
    color:  #059E84;
    &:hover{
      color: #059E84;
    }
  }
}
.disStatus{
  color: #ccc !important;
  &:hover{
    cursor:not-allowed;
  }
}
</style>
